<template>
  <DisplaySection :padding="false" gap="xl">
    <DisplayArticle>
      <AssessmentListItems
        v-if="commingAssessments.length"
        :items="commingAssessments"
        title="Mes prochaines évals"
      />
      <CardContent
        v-else
        theme="neutral-50"
        aspect="square"
        stroke="n"
        variant="outlined"
        elevate="none"
      >
        <AssessmentListEmpty />
      </CardContent>
    </DisplayArticle>

    <DisplayArticle v-if="endedAssessments.length">
      <AssessmentListItems
        :items="endedAssessments"
        title="Mes évals terminées"
      />
    </DisplayArticle>
    <ButtonBase
      v-if="commingAssessments.length"
      class="button-add"
      stroke="n"
      theme="secondary"
      size="small"
      rounded
      :to="`/${Sections.ChildForYou}/eval/ajouter`"
      @click.capture="handleClickAdd"
    >
      Ajouter une nouvelle évaluation
    </ButtonBase>
  </DisplaySection>
</template>
<script setup lang="ts">
import DialogNotASubscriber from '~/components/categories/assessment/dialog/DialogNotASubscriber.vue';

interface Props {
  items: AssessmentListItem[];
}

const props = defineProps({
  items: null
});

const profile = useProfileStore();

const dialog = useDialogStore();

const commingAssessments = computed(() => {
  return props.items.reduce((acc, ass) => {
    if (!ass.ended) acc.push(ass);
    return acc;
  }, []);
});

const endedAssessments = computed(() => {
  return props.items.reduce((acc, ass) => {
    if (ass.ended) acc.push(ass);
    return acc;
  }, []);
});

const handleClickAdd = (e) => {
  if (profile.canCreateNewAssessment) return;
  dialog.open(DialogNotASubscriber, {
    position: 'center',
    level: DialogLevel.Info,
    onClose: () => {
      navigateTo(`/${Sections.ChildForYou}`);
    },
  });
  return e.preventDefault();
};
</script>
<style lang="scss" scoped>
.button-add {
  position: sticky;
  z-index: 1;
  bottom: calc(var(--gap_m) + var(--footer_height));
  align-self: center;
  width: fit-content;
}
</style>
